export default __webpack_public_path__ + "static/media/gateofhell.e57e149c.png";